import Tooltip from '@mui/material/Tooltip';
import { ReactElement, ReactNode, useRef, useState } from 'react';

import styles from './TruncatedText.module.scss';

interface ITruncatedTextProps {
  children: ReactNode;
}

const TruncatedText = ({ children }: ITruncatedTextProps): ReactElement => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const onOpen = () => {
    const element = textRef.current;
    setIsTooltipOpen(!!element && element.scrollHeight > element.clientHeight);
  };

  return (
    <Tooltip
      title={children}
      open={isTooltipOpen}
      onOpen={onOpen}
      onClose={() => setIsTooltipOpen(false)}
      classes={{ tooltip: styles.tooltip }}
    >
      <div ref={textRef} className={styles.text}>
        {children}
      </div>
    </Tooltip>
  );
};

export default TruncatedText;
